import { createContext, useCallback, useContext, useEffect } from 'react';

export type PopoverGateSource = 'metrics' | 'dimensions';
export type PopoverGateState = Record<PopoverGateSource, boolean>;

interface PopoverGateContextValue {
  openPopovers: PopoverGateState;
  setPopoverOpen: (source: PopoverGateSource, isOpen: boolean) => void;
}

const PopoverGateContext = createContext<PopoverGateContextValue | undefined>(undefined);

export function usePopoverGate(source: PopoverGateSource) {
  const context = useContext(PopoverGateContext);
  if (!context) {
    throw new Error('usePopoverGate must be used within a PopoverGateContext provider');
  }

  const { openPopovers, setPopoverOpen } = context;
  const setOpen = useCallback((isOpen: boolean) => setPopoverOpen(source, isOpen), [setPopoverOpen, source]);

  useEffect(() => () => setPopoverOpen(source, false), [setPopoverOpen, source]);

  return { isOpen: openPopovers[source], setOpen };
}

export default PopoverGateContext;
